import { EcmService } from './../../../ecm.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { DataTableComponent } from '../../../../../../shared/data-table/data-table.component';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CgpConfirmationDialogService } from '../../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { DataTableService } from 'src/app/shared/data-table/data-table.service';

interface PartsByProgramData {
  toolId: number;
  programId: number;
  programName: string;
  toolNo: string;
}

@Component({
  selector: 'parts-by-program',
  templateUrl: './parts-by-program.component.html',
  styleUrls: ['./parts-by-program.component.scss']
})
export class PartsByProgramComponent implements OnInit {

  loading = true;
  searchBarInput: any;
  totalParts: number;
  program: PartsByProgramData;
  parts = [];
  searchPartNumber: string;

  pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('partId');

  partProgramcolumns: ColumnDef[] = [
    { field: 'partNumber', name: 'Part Number', editable: false, width: '12em', sortingDisabled: false },
    { field: 'partType', name: 'File Type', editable: false, width: '12em', sortingDisabled: false },
    { field: 'partName', name: 'Part Name', editable: false, width: '22em', sortingDisabled: false },
  ];

  @ViewChild('partsByProgramTable') partsByProgramTable: DataTableComponent;

  constructor(
    private readonly dialogRef: MatDialogRef<PartsByProgramComponent>,
    private readonly toastr: ToastrService,
    private readonly confirmation: CgpConfirmationDialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly ecmService: EcmService,
    private readonly dataTableService: DataTableService
  ) { }

  ngOnInit() {
    this.program = this.data.tool;
  }

  refreshParts() {
    this.ecmService.getPartsByProgram(
      this.program.toolId,
      this.program.programId,
      this.searchPartNumber,
      this.pageOptions
    ).subscribe(data => {
      this.parts = data.data;
      this.totalParts = data.totalCount;
      this.loading = false;
    });
  }

  onLazyLoad(event: LazyLoadEvent) {
    this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
    this.pageOptions.size = event.rows;
    this.pageOptions.sort = event.sortField;
    this.pageOptions.page = event.first / this.pageOptions.size;
    this.refreshParts();
  }

  saveParts() {
    const selected = this.partsByProgramTable.selections
      .map(part => ({ toolId: this.program.toolId, partId: part.partId }));

    if (selected.length < 1) {
      this.toastr.error('Please select a part to update the tool/part relationship.');
      return;
    }

    this.confirmation.showConfirmationDialog({
      title: 'TPRECM',
      message: `Are you sure you want to add these part(s) to the Tool/Part Relationship for Tool No: ${this.program.toolNo}?`,
      alert: 'danger',
      width: '425px',
      onYesClick: () => {
        this.ecmService.createToolPartRelationship(selected)
          .pipe(finalize(() => this.refreshParts()))
          .subscribe();

        this.confirmation.closeConfirmationDialog();
      },
      onNoClick: () => this.confirmation.closeConfirmationDialog()
    });
  }

  searchPartChange(target: any) {
    this.searchPartNumber = target.value;
    this.refreshParts();
  }

  clearSearch() {
    this.searchBarInput = '';
    this.searchPartNumber = '';
    this.refreshParts();
  }

}
